import React from 'react';
import { useTranslation } from 'react-i18next';
import QueueAnim from 'rc-queue-anim';
import TweenOne from 'rc-tween-one';
import { Row, Col, Flex } from 'antd';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender } from '@/utils';

function Content3(props) {
  const getDelay = (e, b) => (e % b) * 100 + Math.floor(e / b) * 100 + b * 100;
  const { t, i18n } = useTranslation();

  const { dataSource, isMobile, ...restProps } = props;
  const { titleWrapper, block } = dataSource;
  return (
    <div {...restProps} {...dataSource.wrapper}>
      <div {...dataSource.page}>

        <OverPack {...dataSource.OverPack}>
          <QueueAnim key="u"
                     type={['right', 'left']}
                     ease={['easeOutQuart', 'easeInOutQuart']}>
            <Row key="row">
              <Col lg={10} xs={24} key="col-1">
                <img className="service-left" src={require('@/assets/home/service-left.png')} />
              </Col>
              <Col lg={13} xs={24} offset={isMobile ? 0 : 1} key="col-2">
                <div {...titleWrapper}>
                  <h1 {...titleWrapper.children[0]}>
                    {t(titleWrapper.children[0].children)}
                  </h1>
                  <h2 {...titleWrapper.children[1]}>
                    {titleWrapper.children[1].children}
                  </h2>
                  <p {...titleWrapper.children[2]}>
                    {t(titleWrapper.children[2].children)}
                  </p>
                </div>
                <Row gutter={24}>
                  {block.children.map((item, index) => {
                    const { children, className, name } = item;
                    return (
                      <Col key={index.toString()} xs={12} md={8} style={{ marginBottom: 24 }}>
                        <img className={className} name={name}
                             src={require(`@/assets/home/${children.icon.children}${i18n.language === 'en' ? '_en' : ''}.png`)} />
                      </Col>
                    );
                  })}
                </Row>
              </Col>
            </Row>
          </QueueAnim>
        </OverPack>
      </div>
    </div>
  );
}

export default Content3;
